<template>
  <div class="aboutpop">
    <div class="about_nei">
        <div class="nei_top">
            <div class="pop_close" @click="popclose">
                <img v-if="theme===2" src="@/assets/popcloseW.svg">
                <img v-else src="@/assets/popcloseB.svg">
            </div>
            <div class="top_img">
                <img src="@/assets/logo.webp" alt="">
            </div>
            <div class="top_name">
                <div class="name1">{{author}}</div>
                <div class="zhiwei1">{{positiona}}</div>
            </div>
        </div>
        <div class="nei_bott">
            <div>
                爱好：{{hobby}}
            </div>
        </div>
    </div>
  </div>
</template>

<script setup>
import {computed,defineEmits} from 'vue'
import { useStore} from 'vuex'
const emit = defineEmits(['updateData'])
const popclose = ()=>{
    emit('popclose')
}
const store = useStore()
const author = computed(()=>{return store.state.app.sysinfo.author})
const positiona = computed(()=>{return store.state.app.sysinfo.position})
const hobby = computed(()=>{return store.state.app.sysinfo.hobby})
const theme = computed(()=>{return store.state.app.theme})
</script>

<style lang="scss" scoped>
.aboutpop{
    width: 20rem;
    height: 20rem;
    border-radius: 1rem;
    background: var(--aboutpop-bac);
    border:1px solid var(--carditem-item-border1);
    position: absolute;
    top: 5rem;
    right: 16rem;
    animation: popin .7s ease-in forwards;
    display: flex;
    justify-content: center;
    align-items: center;
    .about_nei{
        width: 80%;
        height: 80%;
        // background: #f6f6f6;
        border-radius: 1rem;
        transition: all .3s ease-in;
        display: flex;
        flex-direction: column;
        .nei_top{
            flex:.4;
            display: flex;
            align-items: center;
            .top_img{
                img{
                    border-radius: 50%;
                    width: 3rem;
                    height: 3rem;
                    margin-left: 1.5rem;
                }
            }
            .top_name{
                display: flex;
                flex-direction: column;
                margin-left: 1rem;
                >div{
                    margin: .4rem 0;
                }
                .name1{
                    font-size: 1.2rem;
                    font-weight: 600;
                }
                .zhiwei1{
                    font-size: .8rem;
                    color:#b0b0b0;
                }
            }
        }
        .nei_bott{
            flex:.6;
            font-style: italic;
            >div{
                margin-left: 2rem;
                margin-top: 2rem;
            }
        }
    }
    .about_nei:hover{
        background: var(--aboutpop-hover);
    }
}
</style>